import initialState from "./state";
import CRUD_ACTION_TYPES, { getNamedAction } from "actions/CRUD_ACTION_TYPES";
import ACTION_NAMES from "actions/ACTION_NAMES";

function tasksReducer(state = initialState, action) {
    switch (action.type) {
        case getNamedAction(ACTION_NAMES.TCR_BRAND, CRUD_ACTION_TYPES.CREATE_REQUEST):
            return { ...state, isCreatingBrand: true }
        case getNamedAction(ACTION_NAMES.TCR_BRAND, CRUD_ACTION_TYPES.CREATE_SUCCESS):
            return { ...state, isCreatingBrand: false }
        case getNamedAction(ACTION_NAMES.TCR_BRAND, CRUD_ACTION_TYPES.CREATE_FAILURE):
            return { ...state, isCreatingBrand: false }

        case getNamedAction(ACTION_NAMES.TCR_BRAND, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingBrand: true, brand: null }
        case getNamedAction(ACTION_NAMES.TCR_BRAND, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReadingBrand: false, brand: action.data || null }
        case getNamedAction(ACTION_NAMES.TCR_BRAND, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingBrand: false, brand: null }

        case getNamedAction(ACTION_NAMES.TCR_BRAND, CRUD_ACTION_TYPES.UPDATE_REQUEST):
            return { ...state, isUpdatingBrand: true }
        case getNamedAction(ACTION_NAMES.TCR_BRAND, CRUD_ACTION_TYPES.UPDATE_SUCCESS):
            return { ...state, isUpdatingBrand: false }
        case getNamedAction(ACTION_NAMES.TCR_BRAND, CRUD_ACTION_TYPES.UPDATE_FAILURE):
            return { ...state, isUpdatingBrand: false }

        case getNamedAction(ACTION_NAMES.TCR_CAMPAIGN, CRUD_ACTION_TYPES.READ_REQUEST):
            return { ...state, isReadingBrandCampaigns: true, brand_campaigns: [], brand_campaigns_count: 0 }
        case getNamedAction(ACTION_NAMES.TCR_CAMPAIGN, CRUD_ACTION_TYPES.READ_SUCCESS):
            return { ...state, isReadingBrandCampaigns: false, brand_campaigns: action.data.data || [], brand_campaigns_count: action.data.count || 0 }
        case getNamedAction(ACTION_NAMES.TCR_CAMPAIGN, CRUD_ACTION_TYPES.READ_FAILURE):
            return { ...state, isReadingBrandCampaigns: false, brand_campaigns: [], brand_campaigns_count: 0 }

        case getNamedAction(ACTION_NAMES.TCR_CAMPAIGN_ASSIGN_SLOT, CRUD_ACTION_TYPES.UPDATE_REQUEST):
            return { ...state, isAssigningSlot: true }
        case getNamedAction(ACTION_NAMES.TCR_CAMPAIGN_ASSIGN_SLOT, CRUD_ACTION_TYPES.UPDATE_SUCCESS):
            return { ...state, isAssigningSlot: false }
        case getNamedAction(ACTION_NAMES.TCR_CAMPAIGN_ASSIGN_SLOT, CRUD_ACTION_TYPES.UPDATE_FAILURE):
            return { ...state, isAssigningSlot: false }

        case getNamedAction(ACTION_NAMES.TCR_CAMPAIGN, CRUD_ACTION_TYPES.READ_ONE_REQUEST):
            return { ...state, isReadingBrandCampaign: true, brand_campaign: null }
        case getNamedAction(ACTION_NAMES.TCR_CAMPAIGN, CRUD_ACTION_TYPES.READ_ONE_SUCCESS):
            return { ...state, isReadingBrandCampaign: false, brand_campaign: action.data || {} }
        case getNamedAction(ACTION_NAMES.TCR_CAMPAIGN, CRUD_ACTION_TYPES.READ_ONE_FAILURE):
            return { ...state, isReadingBrandCampaign: false, brand_campaign: null }

        case getNamedAction(ACTION_NAMES.TCR_CAMPAIGN, CRUD_ACTION_TYPES.CREATE_REQUEST):
            return { ...state, isCreatingBrandCampaign: true }
        case getNamedAction(ACTION_NAMES.TCR_CAMPAIGN, CRUD_ACTION_TYPES.CREATE_SUCCESS):
            return { ...state, isCreatingBrandCampaign: false }
        case getNamedAction(ACTION_NAMES.TCR_CAMPAIGN, CRUD_ACTION_TYPES.CREATE_FAILURE):
            return { ...state, isCreatingBrandCampaign: false }

        case getNamedAction(ACTION_NAMES.TCR_CAMPAIGN, CRUD_ACTION_TYPES.UPDATE_REQUEST):
            return { ...state, isUpdatingBrandCampaign: true }
        case getNamedAction(ACTION_NAMES.TCR_CAMPAIGN, CRUD_ACTION_TYPES.UPDATE_SUCCESS):
            return { ...state, isUpdatingBrandCampaign: false }
        case getNamedAction(ACTION_NAMES.TCR_CAMPAIGN, CRUD_ACTION_TYPES.UPDATE_FAILURE):
            return { ...state, isUpdatingBrandCampaign: false }

        case getNamedAction(ACTION_NAMES.TCR_CAMPAIGN_SAVE, CRUD_ACTION_TYPES.CREATE_REQUEST):
            return { ...state, isSavingBrandCampaign: true }
        case getNamedAction(ACTION_NAMES.TCR_CAMPAIGN_SAVE, CRUD_ACTION_TYPES.CREATE_SUCCESS):
            return { ...state, isSavingBrandCampaign: false }
        case getNamedAction(ACTION_NAMES.TCR_CAMPAIGN_SAVE, CRUD_ACTION_TYPES.CREATE_FAILURE):
            return { ...state, isSavingBrandCampaign: false }

        case getNamedAction(ACTION_NAMES.TCR_BRAND_OPT_OUT_STATUS, CRUD_ACTION_TYPES.READ_ONE_REQUEST):
            return { ...state, isReadingBrandOptOutStatus: true }
        case getNamedAction(ACTION_NAMES.TCR_BRAND_OPT_OUT_STATUS, CRUD_ACTION_TYPES.READ_ONE_SUCCESS):
            return { ...state, isReadingBrandOptOutStatus: false, brandOptOutStatus: action.data || null }
        case getNamedAction(ACTION_NAMES.TCR_BRAND_OPT_OUT_STATUS, CRUD_ACTION_TYPES.READ_ONE_FAILURE):
            return { ...state, isReadingBrandOptOutStatus: false }

        case getNamedAction(ACTION_NAMES.TCR_BRAND_OPT_OUT_STATUS, CRUD_ACTION_TYPES.UPDATE_REQUEST):
            return { ...state, isUpdatingBrandOptOutStatus: true }
        case getNamedAction(ACTION_NAMES.TCR_BRAND_OPT_OUT_STATUS, CRUD_ACTION_TYPES.UPDATE_SUCCESS):
            return { ...state, isUpdatingBrandOptOutStatus: false }
        case getNamedAction(ACTION_NAMES.TCR_BRAND_OPT_OUT_STATUS, CRUD_ACTION_TYPES.UPDATE_FAILURE):
            return { ...state, isUpdatingBrandOptOutStatus: false }

        default:
            return state;
    }
}

export default tasksReducer;
